import { SalePriceScheduleType } from './sale-price-schedule-type';

export class ProductPriceSchedule {
  id: number;
  salePriceScheduleType: SalePriceScheduleType;
  schedulePrice: number;

  constructor() { }

  static arrayFromJSON(json: string): ProductPriceSchedule[] {
    const values = JSON.parse(json);
    if (!values || !Array.isArray(values)) {
      return null;
    }

    const result: ProductPriceSchedule[] = [];
    for (const item of values) {
      result.push(ProductPriceSchedule.createFromAny(item));
    }

    return result;
  }

  static createFromAny(object: any): ProductPriceSchedule {
    if (object === null || object === undefined) {
      return null;
    }
    const productPriceSchedule = new ProductPriceSchedule();
    productPriceSchedule.id = object.id;
    productPriceSchedule.salePriceScheduleType = object.salePriceScheduleType ? SalePriceScheduleType.createFromAny(object.salePriceScheduleType) : new SalePriceScheduleType();
    productPriceSchedule.schedulePrice = object.schedulePrice;

    return productPriceSchedule;
  }

  toJSON(): any {
    return {
      id: this.id,
      salePriceScheduleTypeId: this.salePriceScheduleType,
      schedulePrice: this.schedulePrice
    };
  }
}
